import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from
'@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import { PurchaseReturnModel } from '../model/index';

@Injectable()
export class PurchaseReturnService {
    private headers = new Headers({
        'Content-Type':
        'application/x-www-form-urlencoded', 'Accept':
        'q=0.8;application/json;q=0.9'
    });
    private purchaseReturnUrl = 'api/purchaseReturn'; // URL to web api
    public  testingTrailUrl = 'api/testingTrail';
    
    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getPurchaseReturnList(query: any): Promise<PurchaseReturnModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.purchaseReturnUrl}/getPurchaseReturnList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getModelDetails(query: any): Promise<PurchaseReturnModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.purchaseReturnUrl}/getModelDetails`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    addSavePurchaseReturn(pageData: any): Promise<any> {
        const url = `${this.purchaseReturnUrl}/addSavePurchaseReturn`;
        return this.http
            .post(url, $.param(pageData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);

    }

    addPurchaseReturn(query: any): Promise<PurchaseReturnModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.purchaseReturnUrl}/addPurchaseReturn`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getPurchaseModelDetails(data: any): Promise<PurchaseReturnModel> {

        const url = `${this.purchaseReturnUrl}/getPurchaseModelDetails`;

        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as PurchaseReturnModel)
            .catch(this.handleError);
    }
    
    getReturnDetails(data: any): Promise<PurchaseReturnModel> {

        const url = `${this.purchaseReturnUrl}/getReturnDetails`;

        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as PurchaseReturnModel)
            .catch(this.handleError);
    }

    deletePurchaseReturn(walkInData: any): Promise<PurchaseReturnModel> {
        const url = `${this.purchaseReturnUrl}/deletePurchaseReturn`;
        return this.http
            .post(url, $.param(walkInData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as PurchaseReturnModel)
            .catch(this.handleError);
    }

    deleteGridList(rowData: any): Promise<PurchaseReturnModel> {
        const url = `${this.purchaseReturnUrl}/deleteGridList`;
        return this.http
            .post(url, $.param(rowData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as PurchaseReturnModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<PurchaseReturnModel> {
        //console.error('An error occurred', error); // for demo
        //purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/purchaseReturn.service.ts